module.exports = __webpack_public_path__ + "img/banner.7928faac.png";